export default {
    isNotNullOrUndefined(value)
    {
        return value !== null && value !== undefined;
    },
    isNullOrUndefined(value)
    {
        return value === null || value === undefined;
    }
}